import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { CheckCircle, Android, Apple } from '@mui/icons-material';
import { useSearchParams } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import './payment-confirmation.scss';

const APP_STORE_URL = 'https://apps.apple.com/br/app/washpass/id6503068980';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=washpass.app&hl=pt_BR';

const PaymentConfirmation = () => {
  const [searchParams] = useSearchParams();
  const fromCheckout = searchParams.get('from') === 'checkout';

  const handleOpenApp = () => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
    const isAndroid = /android/i.test(userAgent);

    const iosDeepLink = 'washpass://';
    const androidIntent = 'intent://#Intent;scheme=washpass;package=washpass.app;end';

    let appUrl = '';
    let fallbackUrl = '/';

    if (isIOS) {
      appUrl = iosDeepLink;
      fallbackUrl = APP_STORE_URL;
    } else if (isAndroid) {
      appUrl = androidIntent;
      fallbackUrl = PLAY_STORE_URL;
    }

    if (isIOS || isAndroid) {
      let appOpened = false;
      const timeoutRef: { current: NodeJS.Timeout | null } = { current: null };

      const handleBlur = () => {
        appOpened = true;
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        window.removeEventListener('blur', handleBlur);
      };

      window.addEventListener('blur', handleBlur);
      window.location.href = appUrl;

      timeoutRef.current = setTimeout(() => {
        if (!appOpened) {
          window.removeEventListener('blur', handleBlur);
          window.location.href = fallbackUrl;
        }
      }, 2500);
    } else {
      window.location.href = '/';
    }
  };

  return (
    <>
      <Navbar />
      <Box className="payment-confirmation">
        <Container maxWidth="md">
          <Box className="payment-confirmation__content">

            <Box className="payment-confirmation__icon-wrapper">
              <Box className="payment-confirmation__icon-circle">
                <CheckCircle sx={{ fontSize: 64, color: 'white' }} />
              </Box>
            </Box>

            <Typography variant="h3" component="h2" className="payment-confirmation__title">
              Assinatura Confirmada!
            </Typography>

            <Typography variant="body1" className="payment-confirmation__description">
              Seu plano foi ativado com sucesso. Aproveite todos os benefícios!
            </Typography>

            {fromCheckout ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5, mt: 1 }}>
                <Typography variant="body2" sx={{ color: '#64748b', mb: 0.5 }}>
                  Baixe o app para começar a usar
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
                  <Button
                    href={PLAY_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    startIcon={<Android />}
                    size="large"
                    className="payment-confirmation__button"
                    sx={{ backgroundColor: '#1e3a5f', '&:hover': { backgroundColor: '#0f2744' } }}
                  >
                    Google Play
                  </Button>
                  <Button
                    href={APP_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    startIcon={<Apple />}
                    size="large"
                    className="payment-confirmation__button"
                    sx={{ backgroundColor: '#1e3a5f', '&:hover': { backgroundColor: '#0f2744' } }}
                  >
                    App Store
                  </Button>
                </Box>
              </Box>
            ) : (
              <Button
                onClick={handleOpenApp}
                variant="contained"
                size="large"
                className="payment-confirmation__button"
              >
                Voltar para o App
              </Button>
            )}
          </Box>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default PaymentConfirmation;
